<div class="card">
  <div class="card-body">
    @if (!hasAvailable()) {
      <ngb-alert type="danger" (closed)="hasAvailable.set(true)">{{ 'CONTRACT.NOT_AVAILABLE_MESSAGE' | translate }}
      </ngb-alert>
    }
    <form [formGroup]="form">
      <div class="row">
        <div class="col-lg-4">
          <datepicker formControlName="startDate" inputValidator label="CONTRACT.START_DATE"/>
        </div>
        <div class="col-lg-4">
          <datepicker formControlName="endDate" inputValidator label="CONTRACT.END_DATE" [minDate]="minEndDate"/>
        </div>
        <div class="col-lg-4">
          <div class="unbefristet">
            <kep-input-label [label]="'CONTRACT.PERMANENT' | translate"></kep-input-label>
            <div class="me-2">
              <p-checkbox [binary]="true" formControlName="permanent" id="permanent" inputId="permanent"/>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-4 ">
        <div class="col-lg-12 fw-bold fs-5 mb-2">
          {{ 'CONTRACT.RESIDENTS_QUESTION' | translate }}
        </div>
        <div class="col-lg-6">
          <p-inputNumber
            [useGrouping]="false"
            class="w-100"
            formControlName="residentsQuantity"
            inputStyleClass="form-control"
            inputValidator
            label="CONTRACT.RESIDENTS_COUNT"
            styleClass="w-100"
          />
        </div>

        <div class="col-lg-6">
          <p-inputNumber
            [useGrouping]="false"
            class="w-100"
            formControlName="roomsQuantity"
            inputStyleClass="form-control"
            inputValidator
            label="CONTRACT.ROOMS_COUNT"
            styleClass="w-100"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <textarea
            class="form-control"
            formControlName="notes"
            inputValidator
            label="APARTMENT.NOTES"
            placeholder=""
            rows="10"
          ></textarea>

        </div>
      </div>

    </form>
  </div>
</div>
<div class="modal-footer d-flex justify-content-between">
  <p-button
    (onClick)="cancel()"
    [label]="'CONTRACT.CANCEL' | translate"
    icon="la la-times"
    iconPos="left"
    severity="danger"
  ></p-button>

  <p-button
    (click)="onSubmit()"
    [disabled]="isPending()"
    [label]="'CONTRACT.SUBMIT' | translate"
    [loading]="isPending()"
    icon="la la-check"
    iconPos="left"
    severity="primary"
  ></p-button>

</div>

